<template>
    <main-layout>

        <!-- Header dégradé -->
        <div class="bg-gradient-to-b from-secondary to-primary">
            <app-header icon="tools" class="text-white pt-4 px-4">
                <h1 class="text-2xl flex items-center gap-3">Ajout outillage</h1>
            </app-header>

            <!-- Action bar (retour) -->
            <action-bar :back="{ name: 'liste-outils' }" class="px-4 pb-6"></action-bar>
        </div>

        <!-- Contenu principal -->
        <div
            class="bg-gradient-to-b from-[#F8FBFF] to-[#E2E9F5] rounded-t-3xl -mt-6 flex-1 overflow-y-auto shadow-xl pb-28">
            <div class="m-2 shadow-2xl rounded-xl overflow-hidden mb-8 bg-white">
                <div class="p-4 md:p-6">
                    <!-- Formulaire -->
                    <form class="grid grid-cols-1 md:grid-cols-2 gap-4" @submit.prevent="onSubmit">

                        <div class="flex flex-col md:col-span-2">
                            <label class="label">Type d'outillage <span class="text-alert">*</span></label>
                            <select name="type" id="type-outil" v-model="outil.type_outil" class="input">
                                <option selected disabled>Sélectionnez un type d'outil</option>
                                <option v-for="typeOutil in types" :key="typeOutil.id" :value="typeOutil">
                                    {{ typeOutil.nom }}
                                </option>
                            </select>
                        </div>

                        <div class="flex flex-col">
                            <label class="label">Marque <span class="text-alert">*</span></label>
                            <input title="mark" type="text" name="marque" id="marque" v-model.trim="outil.marque"
                                maxlength="255" class="input" />
                        </div>

                        <div class="flex flex-col">
                            <label class="label">Modèle <span class="text-alert">*</span></label>
                            <input title="model" type="text" name="nom_appareil" id="nom_appareil"
                                v-model.trim="outil.modele" maxlength="255" class="input" />
                        </div>

                        <div class="flex flex-col">
                            <label class="label">N° de série / repère <span class="text-alert">*</span></label>
                            <input title="idNumber" type="text" name="num_serie" id="num_serie"
                                v-model.trim="outil.numero_serie" maxlength="255" class="input" />
                        </div>

                        <div class="flex flex-col">
                            <label class="label">Distributeur</label>
                            <input title="dist" type="text" name="fournisseur" id="fournisseur"
                                v-model.trim="outil.magasin" maxlength="255" class="input" />
                        </div>

                        <div class="flex flex-col">
                            <label class="label">Date d'achat</label>
                            <input title="buyDate" type="date" name="date_achat" id="date_achat" :max="now"
                                v-model="outil.date_achat" @change="setDateAchat($event)" class="input" />
                        </div>

                        <div class="flex flex-col">
                            <label class="label">N°facture</label>
                            <input title="invoiceNumber" type="text" name="facture_achat" id="facture_achat"
                                v-model.trim="outil.facture_achat" maxlength="255" class="input" />
                        </div>

                        <div class="flex flex-col">
                            <label class="label">N°bon de livraison</label>
                            <input title="deliveryNumber" type="text" name="bon_livraison" id="bon_livraison"
                                v-model.trim="outil.bon_livraison" maxlength="255" class="input" />
                        </div>

                        <div class="flex flex-col">
                            <label class="label">Dernier contrôle <span class="text-alert">*</span></label>
                            <input title="lastControl" type="date" name="last_controle" id="last_controle" :max="now"
                                v-model="outil.date_last_controle" @change="setDateLastControl($event)" class="input" />
                        </div>

                        <!-- Submit -->
                        <div class="md:col-span-2 pt-2">
                            <input type="submit" id="submit-outil" name="save" value="AJOUTER" class="w-full md:w-auto cursor-pointer inline-flex items-center justify-center gap-2
                         bg-primary text-white px-6 py-3 rounded-lg shadow-sm hover:shadow transition" />
                        </div>

                    </form>
                </div>
            </div>
        </div>

    </main-layout>
</template>


<script>

import Outil from '../../js/models/Outil';

export default {

    data() {
        return {
            outil: {
                type_outil: null,
                marque: null,
                modele: null,
                numero_serie: null,
                reference: null,
                magasin: null,
                date_achat: null,
                facture_achat: null,
                bon_livraison: null,
                date_last_controle: null,
                actif: true,
            },
            types: []
        }
    },

    methods: {
        async onSubmit() {
            let outil = this.$data.outil;
            let errors = [];

            if (!outil.type_outil) {
                errors.push("le type d'outil")
            }

            if (!outil.marque) {
                errors.push("la marque")
            }

            if (!outil.modele) {
                errors.push("le modèle")
            }

            if (!outil.numero_serie) {
                errors.push("le numéro de série")
            }

            if (!outil.date_last_controle || outil.date_last_controle === 'Invalid date') {
                errors.push("la date du dernier contrôle")
            }

            if (outil.date_achat === 'Invalid date') {
                outil.date_achat = null;
            }

            if (errors.length !== 0) {
                let txt = errors.join(', ');
                swal('Information(s) manquante(s) :', 'Veuillez renseigner ' + txt + '.', 'error')
            } else {
                let res = await Outil.addOutilOffline(this.$data.outil);

                if (res.errors) {
                    conosole.log(res)
                } else {
                    this.$router.push('liste-outils');
                    swal('Outil ajouté', 'Votre outillage a bien été ajouté et activé', 'success')
                }
            }
        },

        fetchTypes() {
            Outil.getTypes().then(data => this.types = _.sortBy(data, ['nom'])).catch()
        },

        setDateAchat(event) {
            const inputValue = event.target.value;
            this.outil.date_achat = inputValue;
        },
        setDateLastControl(event) {
            const inputValue = event.target.value;
            this.outil.date_last_controle = inputValue;
        }

    },

    mounted() {

        this.fetchTypes()

    },

    computed: {
        now: function () {
            return moment().format('Y-MM-DD')
        }
    }
}
</script>



// WEBPACK FOOTER //
// NewOutil.vue?06bca206